<div class="section">
  <div class="shipping_method_header">
    <div class="heading-primary">{{ $t('shopping.basket.checkout.shipping_method') }}</div>
    <button type="button" class="learn-more-link" @click.stop="openShippingInfo">{{ $t('shopping.basket.checkout.learn_more') }}</button>
  </div>
  <NBRadioGroup v-model="selectedShippingMethod" :options="shippingMethods" valueKey="type">
    <template #default="{ option }">
      <div class="label" v-html="option.description"></div>
    </template>
  </NBRadioGroup>
  <ShippingInfoModal v-model="showShippingInfoModal" />
</div>
